import * as React from 'react'

import { Button, NativeLink, spacing, Text } from 'main/ui'

interface IProps {
  onComplete: () => void
}

export default function Confirmation({ onComplete }: IProps) {
  return (
    <div>
      <Text>
        We’ll remove your listing from our site as soon as possible. If you change your mind, don’t
        hesitate to give us a call at{' '}
        <NativeLink href="tel:+1-415-466-2978">(415) 466-2978</NativeLink> or{' '}
        <NativeLink href="mailto: hello@wonderschool.com">email</NativeLink> us.
      </Text>
      <div css={{ marginTop: spacing.majorScale(4) }}>
        <Button full onClick={() => onComplete()}>
          Done
        </Button>
      </div>
    </div>
  )
}
